import React from 'react';
import CarouselServicos from '../components/carouselServicios';
import FloatingButton from '../components/buttonFlotanteWha';

import Gallery from '../components/gallery';
import "./styles.css"
import CP1 from "../assets/images/cap/CP1.jpg"
import CP2 from "../assets/images/cap/CP2.jpg"
import CP3 from "../assets/images/cap/CP3.jpg"
import CP4 from "../assets/images/cap/CP4.jpg"
import SCP1 from "../assets/images/cap/SCP1.jpg"
import SCP2 from "../assets/images/cap/SCP2.jpg"
import SCP3 from "../assets/images/cap/SCP3.jpg"
import SCP4 from "../assets/images/cap/SCP4.jpg"
import TCP1 from "../assets/images/cap/TCP1.jpg"
import TCP2 from "../assets/images/cap/TCP2.jpg"
import TCP3 from "../assets/images/cap/TCP3.jpg"
import TCP4 from "../assets/images/cap/TCP4.jpg"



const imagenes= [CP1,CP2,CP3,CP4];
const imagenes2=[SCP1,SCP2,SCP3,SCP4];
const imagenes3=[TCP1,TCP2,TCP3,TCP4];


function Servicios(){
    return(
        <div className="fflex flex-col items-center p-10 space-y-10 min-h-screen animated-background">
            <CarouselServicos/>


            <div className='flex flex-col items-center text-center w-full'>
            <h1 className='text-azul-oscuro text-2xl uppercase font-bold hover:text-oro transition-colors duration-300'>
            CAPACITACIÓNES
            </h1>
            <div className='bg-oro h-1 w-44 my-3'></div>
            <p className='text-gris-oscuro font-medium text-lg'>
            Somos especialistas en capacitación y certificación de equipo pesado de la Minería y Construcción de grúas industriales, en la certificación de operadores, Rigger, supervisores de seguridad. Equipos de Izáje.
            </p>
          </div>



          <div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
                <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
                    
                    {/* Galería de imágenes con altura igual */}
                    <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[400px]">
                    <Gallery titulo="Capacitación de Operadores Nuevos" imagenes={imagenes} />
                    </div>

                    {/* Sección de Descripción con altura igual */}
                    <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg text-justify text-gris-oscuro leading-relaxed min-h-[400px] flex flex-col justify-center">
                    <p>
                        A través de estándares establecidos para medir el conocimiento y la competencia requeridos para la operación segura de maquinaria pesada, los candidatos pueden acceder a esta certificación.
                    </p>
                    <br />
                    <p>
                        Certificación de operadores de maquinaria para la construcción, aplicando los lineamientos normativos que corresponden al uso seguro de Maquinaria Pesada, basados en <strong>ASME B30</strong>.
                    </p>
                    <br />
                    <p><strong>Capacitaciones y Certificaciones:</strong></p>
                    <ul className="list-disc list-inside mt-2 space-y-1">
                        <li>Operador de Motoniveladoras</li>
                        <li>Operador de Excavadoras Hidráulicas</li>
                        <li>Operador de Bulldozer</li>
                        <li>Operador de Cargador Frontal</li>
                        <li>Operador de Retroexcavadora</li>
                        <li>Operador de Rodillo Compactador</li>
                        <li>Operador de Mini Cargador</li>
                        <li>Operador de Perforadoras</li>
                        <li>Operador de Chancadoras</li>
                        <li>Operador de Camión Articulado</li>
                        <li>Operador de Camión Fuera de Carretera</li>
                        <li>Operador de Palas Hidráulicas, Eléctricas</li>
                    </ul>
                    </div>

                </div>
    </div>




    <div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
      <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl space-y-6 md:space-y-0 md:space-x-8">
        
       

        {/* 📌 Sección de información */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg overflow-y-auto max-h-[820px]">
        
          <p className="text-gray-700 mb-4">
         <strong> Cursos de Prevención de Riesgos Laborales</strong> <br/>
            <strong>Objetivo:</strong> Calificar y preparar a los participantes sobre el conocimiento 
            básico de los riesgos laborales y su prevención, así como la identificación de los mismos.
          </p>

          <p className="text-gray-700 mb-4">
            <strong>Dirigido a:</strong> Personal en general que desee adquirir conocimientos en la 
            prevención de riesgos laborales en oficinas, construcciones, minería, fábricas, 
            plataformas marítimas y más.
          </p>

          {/* 📌 Lista de Temas */}
          <h3 className="text-lg font-semibold  mb-2">
            Temas Incluidos:
          </h3>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li>Seguridad Industrial</li>
            <li>Evaluación de la Escena del Accidente</li>
            <li>Biomecánica Ocupacional</li>
            <li>Elementos de Protección Personal</li>
            <li>Gestión de la Prevención en Construcción</li>
            <li>Manejo Defensivo</li>
            <li>Prevención de Riesgos</li>
            <li>Radiación Electromagnética</li>
            <li>Riesgo Eléctrico</li>
            <li>Riesgo en proceso de Soldadura</li>
            <li>Transporte de Combustible en Vehículos</li>
            <li>Vibraciones</li>
            <li>Y más...</li>
          </ul>

          <p className="text-gray-700 mt-4">
            <strong>Programas de Entrenamiento:</strong> Nuestros profesionales combinan ejercicios 
            prácticos con materiales multimedia en cada programa de formación. Para más información, 
            póngase en contacto con su representante local de Cecomp Training.
          </p>
        </div>


         {/* 📌 Galería de imágenes */}
         <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex items-center justify-center min-h-[450px]">
          <Gallery titulo="CAPACITACIÓN Y CERTIFICACIÓN EN SEGURIDAD SALUD OCUPACIONAL" imagenes={imagenes2} />
        </div>  
      </div>
    </div>



    <div className="min-h-screen flex flex-col md:flex-row items-stretch justify-center  rounded-2xl p-8">
    <div className="flex flex-col md:flex-row items-stretch w-full max-w-6xl gap-6 md:gap-8">
        
        {/* Galería de imágenes - Misma altura que el texto */}
        <div className="flex-1 bg-white p-4 rounded-2xl shadow-lg flex flex-col h-full">
            <Gallery 
                titulo="CAPACITACION DE OPERADORES NUEVOS DE MAQUINARIA PESADA & GRUAS INDUSTRIALES" 
                imagenes={imagenes3}
                className="h-full flex-grow"
            />
        </div>

        {/* Sección de Descripción - Misma altura que galería */}
        <div className="flex-1 bg-white p-6 rounded-2xl shadow-lg flex flex-col h-full">
            <div className="text-gris-oscuro leading-relaxed text-justify flex-grow overflow-auto">
                <p className="mb-4">
                    Este es un recurso efectivo que las empresas recurren hoy en día para poder ser competitivos a nivel global. 
                    Las empresas de clase mundial saben de la importancia de la capacitación de sus empleados ya que de este modo 
                    obtienen mejores habilidades para desarrollar sus actividades y mejorar su desempeño, traduciéndose en beneficios 
                    directos para su organización.
                </p>
                
                <p className="mb-4">
                    Los recursos de capacitación que ofrecemos en Cecomp Training potencializamos las habilidades de nuestro personal 
                    aumentando sus capacidades. Es por eso que capacitar al personal es la mejor inversión que podemos hacer en la empresa 
                    ya que se traduce en una mayor competitividad y calidad debido a la formación de empleados eficientes y trae consigo 
                    resultados inmediatos.
                </p>
                
                <p>
                    Cecomp Training ofrece formación, capacitación, entrenamiento para operadores de maquinaria pesada de minería y 
                    construcción, y todo tipo de grúas industriales de una forma profesional. Para ello nos apoyamos en la gran experiencia 
                    de nuestro personal llevando a cabo las capacitaciones por medio de teorías, simuladores así como prácticas reales en 
                    Maquinaria Pesada.
                </p>
            </div>
        </div>
    </div>
</div>



          
          
<FloatingButton/>
       
        </div>
        
    );
}
export default Servicios;